import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isUserLoggedIn } from 'apps/user/helpers';

import QuantityInputWithAddToBasket from '../components/QuantityInputWithAddToBasket';

export default withRouter(connect(
  (state, ownProps) => {
    const basketItem = state.basket.items.find(item => item.sku === ownProps.sku);
    const productWarnings = state.basket.productWarnings[ownProps.sku];

    return {
      isLoggedIn: isUserLoggedIn(state.user),
      isUpdating: basketItem && basketItem.isUpdating,
      loggedOutBasket: state.user.betaFeatures.includes('LOGGED_OUT_BASKET'),
      productWarning: Boolean(productWarnings && productWarnings.length),
      quantity: basketItem && basketItem.quantity,
    };
  },
)(QuantityInputWithAddToBasket));
